import styled, { keyframes, css } from 'styled-components';

const slideFromLeft = keyframes`
  from {
    transform: translateX(-100vw);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const SectionTitle = styled.h1`
  font-family: "Playfair Display", serif;
  font-weight: 500;
  font-size: clamp(32px, 6.5vw, 60px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333333;
  margin-top: 10px;
  opacity: 0;
  ${({$animate }) =>
    $animate &&
    css`
    
      animation: ${slideFromLeft} 1.2s ease-out forwards;
    `
  };
`;

export default SectionTitle;
